import { routes } from '@/routes/routes';

/**
 * @param {number} cartCount quantity of items in user cart
 * @param {number} votingCount pending voting proposals
 * @param {number} notificationCount user notifications
 * @returns {object} routing object with badge counts
 */
export const appRoutes = () => ({
  supportTools: {
    ...routes.memberTools,
    childRoutes: {
      search: routes.memberSearch,
      bookmarked: routes.bookmarked,
    },
  },
  adminPortal: {
    ...routes.hqAccess,
    childRoutes: {
      adminUsers: routes.adminUsers,
      roles: routes.roles,
      permissions: routes.permissions,
    },
  },
  salesAdministration: {
    ...routes.salesAdministration,
    childRoutes: {
      salesRoles: routes.salesRoles,
      defaultCommissions: routes.defaultCommissions,
    },
  },
  siteAdministration: {
    ...routes.siteAdministration,
    childRoutes: {
      featureFlags: routes.featureFlags,
      tokenConfiguration: routes.tokenConfiguration,
      nftCollections: routes.nftCollections,
      products: routes.products,
      categories: routes.categories,
      campaigns: routes.campaigns,
      agreements: routes.agreements,
      actionLogs: routes.actionLogs,
    },
  },
  system: {
    ...routes.system,
    childRoutes: {
      health: routes.health,
    },
  },
  manage: routes.manageAccount,
  footer: {
    settings: routes.settings,
    logout: routes.logout,
    login: routes.login,
  },
  documentation: {
    ...routes.documentation,
    childRoutes: {
      gettingStarted: routes.gettingStartedDocs,
      memberTools: routes.memberToolsDocs,
      siteAdministration: routes.siteAdministrationDocs,
      hqAccess: routes.hqAdministrationDocs,
      system: routes.systemDocs,
    },
  },
});
